<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'order/cancelOrder';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.OrderDescription_3')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:  [
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`},
                    { name: "digestType", type: "Number", require: "N", normal: "", describe: `${this.$t('onlineDoc.签名类型')}`, },
                    ]
            },
             { 
                title:`${this.$t('onlineDoc.请求参数')}`, 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
            {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "customerCode",type: "String(30)",require: "N",normal: "J0086024071",describe: `${this.$t('onlineDoc.客户编码（订单类型传2时，必填）')}`},
                {name: "digest",type: "String(50)",require: "N",normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`,describe: `${this.$t('onlineDoc.signnew')}`},
                {name: "orderType",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.订单类型  1（散客），2（协议客户），3（出口国际件）')}`},
                {name: "txlogisticId",type: "String(50)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.客户订单号（传客户自己系统的订单号）')}`},
                {name: "reason",type: "String(50)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.取消原因')}`},
                {name: "billCode",type: "String(50)",require: "N",normal: "",describe: `${this.$t('onlineDoc.运单号')}`}
              ]
            }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`}
                  ]
            },
            {
              title:`${this.$t('onlineDoc.data类型说明')}`,
              value:[
                  {name: "billCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单号')}`},
                  {name: "txlogisticId",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.客户订单号')}`}
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=292508153084379141
    digest=zhDm8HikJuUzN8LjtjjrHw==
    timestamp=1638429345915

Body：
    bizContent="{'txlogisticId': 'SA79595517171', 'orderType': 2, 'reason': 'jiushixiangquxiaoyouruhe', 'customerCode': 'J0086024071', 'digest': '4hQ8qXNkuSJ8cIgJQDFFRA=='}"`,
        //返回示例
        responseCode: JSON.parse(`{"code":"1","msg":"success","data":{"txlogisticId":"SA79595517171","billCode":"UTE010001125329"}}`),

       //错误代码提示
        errcodeJson: [{code:'145003031',msg:`${this.$t('apiTestDoc.业务参数签名失败')}`},
        {code:'145003082',msg:`${this.$t('apiTestDoc.客户订单号不能为空或过长')}`},
        {code:'145003089',msg:`${this.$t('apiTestDoc.取消原因不能为空')}`}]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "292508153084379141",
            digest: "zhDm8HikJuUzN8LjtjjrHw==",
            timestamp: "1638429345915",
          },
          data:{
             bizContent: `{'txlogisticId': 'SA79595517171', 'orderType': 2, 'reason': 'jiushixiangquxiaoyouruhe', 'customerCode': 'J0086024071', 'digest': '4hQ8qXNkuSJ8cIgJQDFFRA=='}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
       //错误代码提示
        errcodeJson: [{code:'145003031',msg:`${this.$t('apiTestDoc.业务参数签名失败')}`},
        {code:'145003082',msg:`${this.$t('apiTestDoc.客户订单号不能为空或过长')}`},
        {code:'145003089',msg:`${this.$t('apiTestDoc.取消原因不能为空')}`}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>